import { render, staticRenderFns } from "./FloatingWarningBanner.vue?vue&type=template&id=2b689af6&scoped=true"
import script from "./FloatingWarningBanner.vue?vue&type=script&lang=js"
export * from "./FloatingWarningBanner.vue?vue&type=script&lang=js"
import style0 from "./FloatingWarningBanner.vue?vue&type=style&index=0&id=2b689af6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b689af6",
  null
  
)

export default component.exports